'use client';

import { c as _c } from "react/compiler-runtime";
import { api } from '~/trpc/react-client';
import { CreditsDisplay } from './CreditsDisplay';
import { ReferralCodeDisplay } from './ReferralCodeDisplay';
import { ReferralLoadingSkeleton } from './ReferralLoadingSkeleton';
import styles from './ReferralPage.module.css';
export function ReferralPage() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      staleTime: 60000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    isLoading
  } = api.referral.getCodeAndCredits.useQuery(undefined, t0);
  let t1;
  if ($[1] !== data?.code || $[2] !== data?.credits || $[3] !== isLoading) {
    t1 = <div className={styles.container}><div className={styles.mainContent}>{isLoading ? <ReferralLoadingSkeleton /> : <><ReferralCodeDisplay code={data?.code ?? null} /><CreditsDisplay credits={data?.credits ?? []} /></>}</div></div>;
    $[1] = data?.code;
    $[2] = data?.credits;
    $[3] = isLoading;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}